export const ROLE_ADMIN = 'admin'

export const ROLE_ACCOUNT_HOLDER = 'account holder'